import React from 'react';
import { CTAButton } from './CTAButton';
export function ProductSection() {
  return <section className="py-16 md:py-24 px-4 bg-forest text-cream relative overflow-hidden" data-id="element-412">
      {/* Background patterns */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#D4A853 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-413"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-414">
        <div className="text-center mb-12" data-id="element-415">
          <span className="inline-block px-4 py-1 rounded-full bg-gold/20 text-gold font-bold tracking-widest uppercase text-sm mb-6 border border-gold/30" data-id="element-416">
            Presentando:
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-gold mb-6 drop-shadow-md" data-id="element-417">
            CENAS ANTI-INFLAMATORIAS
            <br data-id="element-418" />
            EN 15 MINUTOS
          </h2>
          <p className="text-xl md:text-2xl text-cream/90 italic font-serif max-w-3xl mx-auto" data-id="element-419">
            El Sistema Completo Para Desinflamar Tu Abdomen Mientras Duermes —
            Con Comida Real, En Solo 15 Minutos Cada Noche
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12 mt-16" data-id="element-420">
          {/* Product Image */}
          <div className="w-full md:w-1/2 relative group" data-id="element-421">
            <div className="absolute inset-0 bg-gold/30 blur-3xl rounded-full scale-75 group-hover:scale-90 transition-transform duration-700" data-id="element-422"></div>
            <img src="https://cdn.magicpatterns.com/uploads/rdHi3rAEoBrUtDvyQN1xfL/mockup_cenas_antiinf15.png" alt="Sistema Cenas Anti-Inflamatorias" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl animate-[float_5s_ease-in-out_infinite]" data-id="element-423" />
          </div>

          {/* Description */}
          <div className="w-full md:w-1/2 space-y-6 text-lg text-cream/80" data-id="element-424">
            <p className="text-xl text-white font-medium" data-id="element-425">
              Este no es otro recetario de cocina saludable.
            </p>
            <p data-id="element-426">
              Este es un{' '}
              <strong className="text-gold" data-id="element-427">
                sistema de nutrición nocturna
              </strong>{' '}
              diseñado específicamente para el metabolismo de la mujer de más de
              35 años, basado en los principios de la cronobiología nutricional
              y la medicina anti-inflamatoria.
            </p>
            <p data-id="element-428">
              Cada receta, cada combinación de ingredientes, cada especias y
              cada técnica de cocción ha sido seleccionada con un único
              objetivo:
            </p>

            <div className="bg-white/10 p-6 rounded-xl border border-gold/30 backdrop-blur-sm mt-8" data-id="element-429">
              <p className="text-xl font-bold text-gold text-center leading-snug" data-id="element-430">
                Que tu cuerpo entre en modo reparación profunda en cuanto apoyes
                la cabeza en la almohada.
              </p>
            </div>

            <div className="pt-8" data-id="element-431">
              <CTAButton text="VER TODO LO QUE INCLUYE ↓" href="#offer-section" variant="primary" className="bg-gold text-forest hover:bg-gold-light shadow-lg" showTrust={false} data-id="element-432" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}